import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Dropdown, Space } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Box, Flex } from 'atoms';
import { SVG } from 'utils';
import { handleLogout } from 'api/authentication';

export const Round = styled(Box)`
	width: 42px;
	height: 42px;
	border-radius: 50%;
	background-color: ${(props) => props.theme.colors.Bismark};
	color: ${(props) => props.theme.colors.white};
	border: 1px solid white;
	font-size: 12px;
	line-height: 42px;
	text-align: center;
	text-transform: uppercase;
	flex: 0 0 42px;
`;

export const FlexBox = styled(Flex)`
	position: relative;
	align-items: center;
	margin: 10px 0;
	padding-left: 15px;
	cursor: pointer;
`;

export const Logout = styled(Box)`
	border: 1px solid white;
	font-size: 13px;
	line-height: 18px;
	color: #fff;
	text-align: center;
	cursor: pointer;
	padding: 5px 1.5rem;
	background-color: ${(props) => props.theme.colors.primary};
`;

export default function UserInfo() {
	const { me = {} } = useSelector((state) => state.auth);
	const items = [
		{
			label: (
				<Flex>
					<Box fontSize="1rem" lineHeight="1.5" as="span">
						Logout
					</Box>
				</Flex>
			),
			key: '1',
			icon: <SVG.LogoutIcons />,
		},
	];

	const handleMenuClick = async () => {
		await handleLogout();
	};

	const menuProps = {
		items,
		onClick: handleMenuClick,
	};

	return (
		<Dropdown menu={menuProps} placement="bottom">
			<Box onClick={(e) => e.preventDefault()}>
				<Space>
					<UserOutlined />
					{me.user_name}
				</Space>
			</Box>
		</Dropdown>
	);
}
